module.exports = __webpack_public_path__ + "static/media/Down-arrow.017b368a.svg";